export const loginMenuLinks = {
  "de": {
    "PRODUKT WÄHLEN UND EINFACH ANMELDEN": [
      {
        linkName: "Firmendatenbank",
        url: "https://www.bisnode-firmendatenbank.de/",
        onNewTab: true,
      },
      {
        linkName: "Payment Performance Insights",
        url: "https://sso.dnb.com/",
        onNewTab: true,
      },
      {
        linkName: "Upik",
        url: "https://www.dnb.com/de-de/upik/",
        onNewTab: false,
      },
      {
        linkName: "D&B Finance Analytics",
        url: "https://sso.dnb.com/",
        onNewTab: true,

      },
      {
        linkName: "D&B Country Risk Services",
        url: "https://www.dnbcountryrisk.com/index.htm",
        onNewTab: true,

      },
      {
        linkName: "D&B Data Integration Toolkit",
        url: "https://toolkit-api.dnb.com/locked/login.asp?Lang=EN&amp;msg=S&amp;pg=locked/find.asp?stat_link=null&amp;i",
        onNewTab: true,

      },
      {
        linkName: "D&B Hoovers",
        url: "https://sso.dnb.com/",
        onNewTab: true,

      },
      {
        linkName: "D&B Insights",
        url: "https://insights.dnbgermany.de/insights/login",
        onNewTab: true,

      },
      {
        linkName: "D&B Onboard",
        url: "https://sso.dnb.com/",
        onNewTab: true,
      }
    ]
  },
  "ch": {
    "WÄHLEN SIE IHR PRODUKT": [
      {
        linkName: "Credit Check (BCC)",
        url: "https://www.mybcc.ch/de/bisnode/",
        onNewTab: true,
      },
      {
        linkName: "Firmendatenbank",
        url: "https://bisnode-firmendatenbank.ch/",
        onNewTab: true,
      },
      {
        linkName: "Trade Analysis Plattform",
        url: "https://tradeanalysis.bisnode.ch/login/",
        onNewTab: true,
      }
    ],
    "DUN & BRADSTREET-LÖSUNGEN": [
      {
        linkName: "D&B Finance Analytics",
        url: "https://sso.dnb.com/",
        onNewTab: true,
      },
      {
        linkName: "D&B Data Manager",
        url: "http://dnbdatamanager.com/",
        onNewTab: true,
      },
      {
        linkName: "D&B Risk Analytics",
        url: "https://riskanalytics.dnb.com/en-US/login",
        onNewTab: true,
      },
      {
        linkName: "D&B Data Integration Toolkit",
        url: "https://toolkit-api.dnb.com/locked/login.asp?Lang=EN&msg=S&pg=locked/find.asp?stat_link=010000",
        onNewTab: true,
      },
      {
        linkName: "D&B Global Reference Solution",
        url: "https://solutions.dnb.com/grs/jsp/EN-GB/GRSFrameLogon.jsp?news_country=1051",
        onNewTab: true,
      },
      {
        linkName: "D&B Hoovers",
        url: "https://sso.dnb.com/",
        onNewTab: true,
      },
      {
        linkName: "D&B Onboard",
        url: "https://sso.dnb.com/",
        onNewTab: true,
      },
      {
        linkName: "D&B Portfolio Manager",
        url: "https://www.portfoliomanager.dnb.com/V7.2/ContentPages/Logon/SecureLogon.aspx",
        onNewTab: true,
      },
      {
        linkName: "Payment Performance Insights",
        url: "https://globaltrade.dnb.com/",
        onNewTab: true,
      },
    ]
  },
  "at": {
    "WÄHLEN SIE IHR PRODUKT": [
      {
        linkName: "Firmendatenbank",
        url: "https://www.firmendatenbank.bisnode.at/",
        onNewTab: true,
      },
      {
        linkName: "Widata",
        url: "https://www.widata.at/login.php",
        onNewTab: true,
      },
      {
        linkName: "D&B Finance Analytics",
        url: "https://sso.dnb.com/",
        onNewTab: true,
      },
      {
        linkName: "D&B Hoovers",
        url: "https://sso.dnb.com/",
        onNewTab: true,
      },
      {
        linkName: "D&B Onboard",
        url: "https://sso.dnb.com/",
        onNewTab: true,
      },
      {
        linkName: "D&B Portfolio Manager",
        url: "https://www.portfoliomanager.dnb.com/App/ContentPages/Logon/SecureLogon.aspx",
        onNewTab: true,
      },
      {
        linkName: "Global Reference Solution (GRS)",
        url: "https://solutions.dnb.com/grs/jsp/EN-GB/GRSFrameLogon.jsp?news_country=869",
        onNewTab: true,
      },
      {
        linkName: "D&B DBAI",
        url: "https://online.bisnode.at/",
        onNewTab: true,
      },
    ]
  },
  "hu": {
    "MEGOLDÁSOK ÉS TERMÉKEK<br/>DUN & BRADSTREET": [
      {
        linkName: "D&B Finance Analytics",
        url: "https://sso.dnb.com/",
        onNewTab: true,
      },
      {
        linkName: "D&B Hoovers",
        url: "https://app.dnbhoovers.com/login",
        onNewTab: true,
      },
    ],
    "EGYÉB MEGOLDÁSOK<br/>ÉS TERMÉKEK": [
      {
        linkName: "PartnerRadar",
        url: "https://www.partnerradar.hu/hu/login",
        onNewTab: true,
      },
      {
        linkName: "PartnerControl",
        url: "https://www.partnercontrol.hu/bejelentkezes",
        onNewTab: true,
      },
      {
        linkName: "PartnerManager",
        url: "https://www.partnermanager.hu/bejelentkezes",
        onNewTab: true,
      }
    ]
  },
  "pl": {
    "ZALOGUJ SIĘ": [
      {
        linkName: "Baza Danych",
        url: "https://on-line.dnb.com.pl/Login.aspx",
        onNewTab: true,
      },
      {
        linkName: "D&B Finance Analytics",
        url: "https://sso.dnb.com/",
        onNewTab: true,
      },
      {
        linkName: "D&B Risk Analytics",
        url: "https://riskanalytics.dnb.com/en-US/login",
        onNewTab: true,
      },
      {
        linkName: "D&B Onboard",
        url: "https://sso.dnb.com/",
        onNewTab: true,
      },
      {
        linkName: "D&B Indued",
        url: "https://indued.altares.com/users/sign_in",
        onNewTab: true,
      },
      {
        linkName: "D&B Hoovers",
        url: "https://app.dnbhoovers.com/login",
        onNewTab: true,
      },
      {
        linkName: "International Payment Monitor",
        url: "https://ipm.dnb.com.pl/",
        onNewTab: true,
      },
    ],
    "ZAPOZNAJ SIĘ Z DOKUMENTAMI I<br/>REGULAMINAMI DUN&BRADSTREET:": [
      {
        linkName: "Warunki i regulaminy",
        url: "https://www.dnb.com/content/dnb-pl/pl/strona-glowna/produkty/warunki-i-regulaminy.html",
        onNewTab: true,
      },
    ]
  },
  "us": {
    "headingDnbProduct": "D&B Products",
    "headingMyCompanyInfo": "My Company Info",
    "dnbProductsData": [
      {
        linkName: "Country Insight Services",
        url: "http://www.dnbcountryrisk.com/",
        onNewTab: false,
      },
      {
        linkName: "D&B Finance Analytics Credit Intelligence",
        url: "https://financeanalytics.dnb.com/",
        onNewTab: false,
      },
      {
        linkName: "D&B Onboard",
        url: "https://onboard.dnb.com/onboard/",
        onNewTab: false,
      },
      {
        linkName: "Analytics Studio",
        url: "https://sso.dnb.com/",
        onNewTab: false,
      },
      {
        linkName: "D&B Rev.Up ABX",
        url: "https://app.lattice-engines.com/login/form",
        onNewTab: false,
      },
      {
        linkName: "D&B Hoovers",
        url: "https://app.dnbhoovers.com/",
        onNewTab: false,
      },
      {
        linkName: "D&B Connect",
        url: "https://connect.dnb.com/",
        onNewTab: false,
      },
      {
        linkName: "Global Reference Solution",
        url: "https://solutions.dnb.com/grs/",
        onNewTab: false,
      },
      {
        linkName: "D&B Risk Analytics - Compliance Intelligence",
        url: "https://riskanalytics.dnb.com/",
        onNewTab: false,
      },
      {
        linkName: "D&B Risk Analytics - Supplier Intelligence",
        url: "https://riskanalytics.dnb.com/",
        onNewTab: false,
      }
    ],
    "myCompanyInfoData": [
      {
        linkName: "View, Manage, Update information",
        url: "https://www.dnb.com/duns-number/view-update-company-credit-file.html",
        onNewTab: false,
      },
      {
        linkName: "myD&B",
        url: "https://my.dnb.com/login",
        onNewTab: false,
      },
    ]
  },
}



